<template>
  <div class="Camera">
    <v-toolbar dark class="buttons" width="100%" absolute>
      <v-spacer></v-spacer>
      <v-btn text rounded @click="closeCamera"><v-icon>mdi-arrow-left-circle</v-icon></v-btn>
      <v-btn text rounded @click="changeCamera"><v-icon>mdi-rotate-3d-variant</v-icon></v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div class="zone"></div>
    <qrcode-stream class="camera" @decode="onDecode" @init="onInit"  :paused="camera.paused"
                   :camera="camera.facingMode"/>
  </div>
</template>

<script>

import './_Camera.scss'

const REAR_CAMERA = 'rear'
const FRONT_CAMERA = 'front'

export default {
  data () {
    return {
      data: null,
      manual: false,
      camera: {
        paused: false,
        enabled: true,
        facingMode: 'auto'
      }
    }
  },
  destroyed () {
    this.scanDisabled()
  },
  methods: {
    onDecode (content) {
      if (content.length > 0) {
        this.data = content
        this.scanDisabled()
        this.processCode()
        return
      }
      this.scanDisabled()
      this.scan()
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        let message = ''
        if (error.name === 'NotAllowedError') {
          message = 'ERROR: you need to grant camera access permission'
        } else if (error.name === 'NotFoundError') {
          message = 'ERROR: no camera on this device'
        } else if (error.name === 'NotSupportedError') {
          message = 'ERROR: secure context required (HTTPS, localhost)'
        } else if (error.name === 'NotReadableError') {
          message = 'ERROR: is the camera already in use?'
        } else if (error.name === 'OverconstrainedError') {
          message = 'ERROR: installed cameras are not suitable'
          this.camera.facingMode = 'auto'
        } else if (error.name === 'StreamApiNotSupportedError') {
          message = 'ERROR: Stream API is not supported in this browser'
        }
        console.log(message)
      }
    },
    scan () {
      this.camera.paused = false
      this.camera.enabled = true
      this.camera.facingMode = FRONT_CAMERA
    },
    changeCamera () {
      this.camera.facingMode = this.camera.facingMode === FRONT_CAMERA ? REAR_CAMERA : FRONT_CAMERA
    },
    scanDisabled () {
      this.camera.enabled = false
      this.camera.paused = true
      this.camera.facingMode = null
    },
    closeCamera () {
      this.scanDisabled()
      this.$emit('close')
    },
    processCode () {
      this.$emit('close', this.data)
    }
  }
}
</script>
